<template>
  <div class="reservation">
    <content-section
      title="Contatti a cui riceverai le informazioni del tuo volo "
    >
      <template>
        <div
          v-for="(contact, index) in contacts"
          :key="_uid + index"
          class="reservation__wrapper"
        >
          <div class="reservation__user-info">
            <span class="reservation__user-info_label">Nome e cognome:</span>
            <span class="reservation__user-info_value">
              {{ contact.addresseeName.firstName }}
              {{ contact.addresseeName.middleName }}
              {{ contact.addresseeName.lastName }}
            </span>
          </div>
          <div
            v-if="contact.emailAddress"
            class="reservation__user-info"
          >
            <span class="reservation__user-info_label">Email di riferimento:</span>
            <span class="reservation__user-info_value">{{ contact.emailAddress }}</span>
          </div>
          <div
            v-if="contact.phones && contact.phones.length"
            class="reservation__user-info"
          >
            <span class="reservation__user-info_label">Telefono:</span>
            <span class="reservation__user-info_value">+{{ contact.phones[0].countryCallingCode }} {{ contact.phones[0].number }}</span>
          </div>
        </div>

        <!-- codici prenotazione: valorizzati solo in pagina conferma (il checkout non li passa) -->
        <div
          v-if="booking_reference || assistance_code"
          class="reservation__wrapper"
        >
          <div v-if="booking_reference" class="reservation__user-info">
            <span class="reservation__user-info_label">Codice di riferimento della prenotazione:</span>
            <span class="reservation__user-info_value">{{ booking_reference }}</span>
          </div>
          <div v-if="assistance_code" class="reservation__user-info">
            <span class="reservation__user-info_label">Codice di assistenza VadoBay:</span>
            <span class="reservation__user-info_value">
              {{ assistance_code }}
              <small v-if="assistance_code" class="reservation__note">
                (questo non è il codice del tuo volo ma il riferimento della
                prenotazione su {{ assistance_brand }}: usalo per comunicare con la
                nostra assistenza in caso di bisogno)
              </small>
            </span>
          </div>
        </div>
      </template>
    </content-section>
  </div>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "reservation",

  components: {
    "content-section": ContentSection,
  },

  props: {
    // elenco contatti a cui inviare le informazioni del volo
    contacts: {
      type: Array,
      default: () => [],
    },
    // codice di riferimento della prenotazione presso la compagnia (solo conferma)
    booking_reference: {
      type: String,
      default: "",
    },
    // codice di assistenza interno (confirm_code) (solo conferma)
    assistance_code: {
      type: String,
      default: "",
    },
    // brand mostrato nella nota del codice di assistenza (solo conferma)
    assistance_brand: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.reservation {

  &__wrapper {
    margin-top: $grid-gutter-width / 2;
  }

  &__user-info {
    margin-bottom: $grid-gutter-width / 10;

    &:last-child {
      margin-bottom: 0;
    }

    &_label {
      margin-right: $grid-gutter-width / 4;
    }
    &_value {
      font-weight: $vb-font-weight-semibold;
    }
  }
}
</style>